import axios from "axios";
import { apiURL } from "@/config";

import { cartToken } from "@/services/cart";

export async function fetchProducts(slug) {
  return await axios.get(`${apiURL}taxon-products/by-slug/${slug}`, {
    responseType: "json",
  });
}

export async function fetchProductsByCode(code) {
  return await axios.get(`${apiURL}products/by-code/${code}`, {
    responseType: "json",
  });
}

export async function fetchProductConfig(name) {
  return await axios.get(`${apiURL}products/by-code/${name}/config/`, {
    responseType: "json",
  });
}

export async function fetchProductCodeConfig(code) {
  let url = `${apiURL}products/by-code/${code.productCode}/config/${code.configCode}`;

  if (code.itemId) {
    url += `/${code.itemId}`;
  }

  return await axios.get(url, {
    responseType: "json",
  });
}

export async function saveProductCodeConfig(data) {
  const url = `${apiURL}products/by-code/${data.productCode}/config/${data.configCode}`;
  // if (data.itemId) {
  //   url += `/${data.itemId}`;
  // }

  return await axios.post(
    url,
    data.body,
    {
      responseType: "json",
    }
  );
}

export async function deleteFileProductCodeConfig(data) {
  const token = cartToken();
  return await axios.delete(
    `${apiURL}carts/${token}/file/${data.productCode}/config/${data.configCode}`,
    { data: data.body },
    {
      responseType: "json",
    }
  );
}

export async function fetchCategories() {
  return await axios.get(`${apiURL}taxons`, {
    responseType: "json",
  });
}

export async function getVariant(code, codes) {
  return await axios.get(`${apiURL}products/by-code/${code}/variant?${codes}`, {
    responseType: "json",
  });
}